<template>
	<div class="conten">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">
				
				<el-form-item>
					<el-button type="primary" @click='add'>新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<div>
			<el-table :data="tableData" style="width: 100%" border>
				<el-table-column prop="goodsAttrKeyName" label="属性名称" align="center">
				</el-table-column>
				<el-table-column prop="goodsAttrValues" label="属性值" align="center">
				</el-table-column>	
				<el-table-column prop="attrKeySort" width="80" label="排序" align="center">
				</el-table-column>				
				<el-table-column fixed="right" label="操作" width="150" align="center">
					<template slot-scope="scope">
						<el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>						
					</template>
				</el-table-column>
			</el-table>
		</div>
		
		<el-dialog  :close-on-click-modal='false' :close-on-press-escape='false' :title="isAdd?'新增':'修改'" :visible.sync="dialogVisible" :modal='false'  width="600px">
			<el-form :model="form">
				<el-form-item label="属性名称" label-width='100px'>
					<el-input v-model="form.goodsAttrKeyName" maxlength="18" autocomplete="off" placeholder="请输入属性名称"></el-input>
				</el-form-item>
				<el-form-item label="属性值" label-width='100px'>
					<el-input v-model="form.goodsAttrValues"autocomplete="off" placeholder="请输入属性值"></el-input>
					<div style="color: red;">注：属性值以英文逗号隔开“,” 列 白色,黑色,蓝色</div>
				</el-form-item>
				<el-form-item label="属性排序" label-width='100px'>
					<el-input v-model.number="form.attrKeySort" maxlength="18" autocomplete="off" placeholder="请输入属性排序"></el-input>
				</el-form-item>							
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="sub">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props:["goodsId"],
		data() {
			return {
				tableData: [],
				dialogVisible: false,
				isAdd: true,
				form: {
					goodsAttrKeyName:"",
					goodsAttrValues:'',
					goodsId:Number,
					attrKeySort:"",
					goodsAttrKeyId:""
				},

			}
		},
		created() {
			this.getAttr()
		},
		methods: {
			//新增
			add() {
				this.dialogVisible = true
				this.isAdd = true
				this.form={
					goodsAttrKeyName:"",
					goodsAttrValues:'',
					goodsId:Number,
					attrKeySort:"",
					goodsAttrKeyId:""
				}
			},
			//提交
			sub(){
				this.form.goodsId=this.goodsId
				if (this.form.goodsAttrKeyName.length == 0) {
					this.$message('请输入属性名称');
					return false
				}
				if (this.form.goodsAttrValues.length == 0) {
					this.$message('请输入属性值');
					return false
				}
				
				if (!this.isNullNum(this.form.attrKeySort)) {
					this.$message('排序请输入为数字');
					return false
				}
				
				
				var url=this.isAdd?"/goods/addAttr":"/goods/updateAttr"
				if(this.isAdd){
					this.httpPost(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('新增成功');
							this.dialogVisible = false
							this.getAttr()
						}
					})
				}else{
					this.httpPost(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('修改成功');
							this.dialogVisible = false
							this.getAttr()
						}
					})
				}
				
			},
			
			//删除
			del(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.httpPost("/goods/delAttr?"+this.$qs.stringify({goodsAttrKeyId:row.goodsAttrKeyId})).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.getAttr()
						}
					})
				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消删除'
					// });
				});
			},
			//修改
			edit(row) {
				this.dialogVisible = true
				this.isAdd = false
				this.form=JSON.parse(JSON.stringify(row))			
			},
							
			//获取数据
			getAttr() {
				this.httpPost("/goods/getAttr?"+this.$qs.stringify({
						goodsId: this.goodsId
					})).then(res => {
					if (res.code == 200) {
						this.tableData = res.data
					}
				})

			},
			

		},


	}
</script>

<style scoped lang='scss'>
	/* .page {
		padding: 20px 0;
	} */
	.conten{
		padding: 0px 20px;
		min-height: 50vh;
	}
	
</style>
